import React from 'react';

import Stars from '../vector/stars';
import ThumbsUp from '../vector/thumbs_up';

import {
  Wrapper,
  Title,
  Picture,
  Name,
  Text,
  TextStars,
  TextThumbsUp,
  Points,
} from './styled';

const CardLarge = ({
  user,
  points = 0,
  pointsPrefix = '+',
  pointsSuffix = ' Points',
  title = 'Nice One!',
  zoom = null,
}) => (
  <Wrapper className="wrapper" zoom={zoom}>
    <Title>
      <TextThumbsUp>
        <ThumbsUp height="1.8em" />
      </TextThumbsUp>
      {title}
    </Title>

    <Picture src={user.links.avatar ? user.links.avatar : null} zoom={zoom} />

    <Name>
      {user.attributes.first_name} {user.attributes.last_name}
    </Name>

    <Text>
      <Points>
        {pointsPrefix}
        {points}
      </Points>
      {pointsSuffix}

      <TextStars>
        <Stars />
      </TextStars>
    </Text>
  </Wrapper>
);

export default CardLarge;
